<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">通话记录</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body">

        <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="400" border>

          <el-table-column prop="callType" label="呼叫类型" ></el-table-column>
          <el-table-column label="呼叫状态">
            <template slot-scope="scope">
              <span v-if="scope.row.isAnswered==0">未接通</span>
              <span v-if="scope.row.isAnswered==1">已接通</span>
            </template>
          </el-table-column>
          <el-table-column label="紧急呼叫">
            <template slot-scope="scope">
              <span v-if="scope.row.isEmergencyCall==true">是</span>
              <span v-if="scope.row.isEmergencyCall==false">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="callDuration" label="通话时长" ></el-table-column>
          <el-table-column prop="createTime" :formatter="timefilter" label="呼叫时间"></el-table-column>

        </el-table>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "WangGuanData",
  data() {
    return {
      tableLoading:false,

      deviceXDuCode: '',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

    }
  },
  components: {

  },

  methods: {
    init(row) {
      this.deviceXDuCode = row.deviceXDuCode;
      this.getList();
    },

    closeSelf() {
      this.$emit("closeAdd");
    },



    timefilter(row,index,column){
      return timefilters(column)
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DeviceXDu/PageByDeviceXDuCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceXDuCode: this.deviceXDuCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error === 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems=response.data.data.pageInfo.total;

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      })

    },




  }


}
</script>

<style lang="scss" scoped>

</style>
